import React, { useEffect, useState } from "react";
import { Grid, Stack } from "@mui/material";

import { Select, Input } from "../Common";
import { TranslateW } from "../../Utils/Languages/Translate";

const UserAddressForm = ({
    userInfo,
    options,
    onHandleValueChanged,
    isFieldValid,
}) => {
    const [filteredState, setFilteredState] = useState([]);

    useEffect(() => {
        const states = options.state.filter(
            (x) => x.countryCode == userInfo.country
        );
        setFilteredState(states);
    }, [userInfo.country]);

    return (
        <>
            <Grid container spacing={6}>
                <Grid item xs={6} md={6}>
                    <p className="inputfields-header-label">
                        {TranslateW("Profile.Address")}
                    </p>
                    <Stack spacing={3}>
                        <Input
                            fullWidth
                            value={userInfo.address1}
                            label={TranslateW("Profile.Address1")}
                            onChange={(e) => onHandleValueChanged("address1", e.target.value)}
                        />
                        <Input
                            fullWidth
                            value={userInfo.address2}
                            label={TranslateW("Profile.Address2")}
                            onChange={(e) => onHandleValueChanged("address2", e.target.value)}
                        />
                        <Input
                            fullWidth
                            value={userInfo.city}
                            label={TranslateW("Profile.City")}
                            onChange={(e) => onHandleValueChanged("city", e.target.value)}
                        />
                        <Input
                            fullWidth
                            value={userInfo.county}
                            label={TranslateW("Profile.County")}
                            onChange={(e) => onHandleValueChanged("county", e.target.value)}
                        />
                    </Stack>
                </Grid>
                <Grid item xs={6} md={6}>
                    <Stack spacing={3} sx={{ marginTop: "30px" }}>
                        <Input
                            fullWidth
                            type="number"
                            value={userInfo.zip}
                            label={TranslateW("Profile.ZipCode")}
                            onChange={(e) => onHandleValueChanged("zip", e.target.value)}
                        />
                        <Select
                            required
                            value={userInfo.country}
                            error={isFieldValid(userInfo.country)}
                            label={TranslateW("Profile.Country")}
                            options={options.country}
                            onChange={(e) => onHandleValueChanged("country", e.target.value)}
                        />
                        {filteredState.length > 0 ? (
                            <Select
                                required
                                value={userInfo.state}
                                error={isFieldValid(userInfo.state)}
                                label={TranslateW("Profile.StateProvince")}
                                options={filteredState}
                                onChange={(e) => onHandleValueChanged("state", e.target.value)}
                            />
                        ) : (
                            <Input
                                fullWidth
                                value={userInfo.state}
                                label={TranslateW("Profile.StateProvince")}
                                onChange={(e) => onHandleValueChanged("state", e.target.value)}
                            />
                        )}
                    </Stack>
                </Grid>
            </Grid>
        </>
    );
};

export default UserAddressForm;
